import { AFREECATV_DOMAIN, SEARCH_API_URL } from "../constant/config";
import { handleFetchErrors, handleFailedToFetch } from "../helpers";

//Post list
export const MODE_HOT_KEYWORD = "MODE_HOT_KEYWORD";
export const MODE_RECOMMEND_KEYWORD = "MODE_RECOMMEND_KEYWORD";
export const MODE_LATEST_KEYWORD = "MODE_LATEST_KEYWORD";

export const FETCH_AUTO_COMPLETE_SUCCESS = "FETCH_AUTO_COMPLETE_SUCCESS";
export const FETCH_AUTO_COMPLETE_FAILURE = "FETCH_AUTO_COMPLETE_FAILURE";

const RECENT_COOKIE_KEY = "_csk";
/**
 * 게시판리스트 불러오기
 * @param {*} bbs_no
 */
function setCookie(name, value, days, domain = AFREECATV_DOMAIN) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=" + domain;
}
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

export function fetchSearchHotKeyword() {
	return (dispatch) => {
		//최근검색어가 있는지
		//let csk = cookie.load(RECENT_COOKIE_KEY);
		let csk = getCookie(RECENT_COOKIE_KEY);
		// if (csk === "" || csk === undefined) {
		// 	//실시간 핫이슈
		// 	dispatch({ type: MODE_HOT_KEYWORD });
		//
		// 	const url = `${SEARCH_API_URL}?m=hotKeyword&v=1.0&c=UTF-8&_=${new Date().getTime()}`;
		// 	//로딩
		// 	fetch(url, {
		// 		credentials: "include",
		// 	})
		// 		.then(handleFetchErrors, handleFailedToFetch)
		// 		.then((response) => response.json())
		// 		.then((response) => {
		// 			dispatch({
		// 				type: FETCH_AUTO_COMPLETE_SUCCESS,
		// 				payload: {
		// 					mode: MODE_HOT_KEYWORD,
		// 					data: response.HOT,
		// 				},
		// 			});
		// 		})
		// 		.catch((error) => {
		// 			dispatch({
		// 				type: FETCH_AUTO_COMPLETE_FAILURE,
		// 				payload: error ? error : { code: 0, message: error },
		// 			});
		// 		});
		// } else {
		//최근 검색어
		if (csk === "" || csk === undefined || csk === null) {
			return;
		} else {
			const szCKKeyword = unescape(csk);
			const latestKeyword = szCKKeyword.split(String.fromCharCode(12));
			dispatch({
				type: FETCH_AUTO_COMPLETE_SUCCESS,
				payload: {
					mode: MODE_LATEST_KEYWORD,
					data: latestKeyword.splice(0, 10),
				},
			});
		}
	};
}

export function appendCSk(keyword) {
	keyword = keyword.trim();
	if (keyword === "" || keyword === undefined) {
		return;
	}
	let csk = getCookie(RECENT_COOKIE_KEY);
	let szCKKeyword,
		latestKeyword = [];
	if (csk !== "" && csk !== undefined && csk !== null) {
		szCKKeyword = unescape(csk);
		latestKeyword = szCKKeyword.split(String.fromCharCode(12));
	}
	//추가
	latestKeyword.unshift(keyword);
	var uniqKeyword = latestKeyword.reduce(function(a, b) {
		if (a.indexOf(b) < 0) a.push(b);
		return a;
	}, []);

	uniqKeyword = uniqKeyword.splice(0, 10);
	szCKKeyword = uniqKeyword.join(String.fromCharCode(12));
	csk = escape(szCKKeyword);

	// const expires = new Date();
	// expires.setDate(expires.getDate() + 1);
	// cookie.save(RECENT_COOKIE_KEY, csk, { domain: AFREECATV_DOMAIN, path: "/", expires });
	setCookie(RECENT_COOKIE_KEY, csk, 1);
}

export function removeCSk(keyword) {
	return (dispatch) => {
		if (keyword === "" || keyword === undefined) {
			return;
		}
		let csk = getCookie(RECENT_COOKIE_KEY);
		let szCKKeyword,
			latestKeyword = [];
		if (csk !== "" && csk !== undefined && csk !== null) {
			szCKKeyword = unescape(csk);
			latestKeyword = szCKKeyword.split(String.fromCharCode(12));
		}

		//제거
		const newLatestKeyword = latestKeyword.filter((word) => {
			return !(word === keyword);
		});
		szCKKeyword = newLatestKeyword.join(String.fromCharCode(12));
		csk = escape(szCKKeyword);
		setCookie(RECENT_COOKIE_KEY, csk, 1);

		dispatch({
			type: FETCH_AUTO_COMPLETE_SUCCESS,
			payload: {
				mode: MODE_LATEST_KEYWORD,
				data: newLatestKeyword,
			},
		});
	};
}

export function fetchSearchRecommendKeyword(keword) {
	return (dispatch) => {
		dispatch({ type: MODE_RECOMMEND_KEYWORD });

		const url = `${SEARCH_API_URL}?m=autoJaso&v=1.0&c=UTF-8&d=${keword}&_=${new Date().getTime()}`;
		//로딩
		fetch(url, {
			credentials: "include",
		})
			.then(handleFetchErrors, handleFailedToFetch)
			.then((response) => response.json())
			.then((response) => {
				dispatch({
					type: FETCH_AUTO_COMPLETE_SUCCESS,
					payload: {
						mode: MODE_RECOMMEND_KEYWORD,
						data: response.list,
					},
				});
			})
			.catch((error) => {
				dispatch({
					type: FETCH_AUTO_COMPLETE_FAILURE,
					payload: error ? error : { code: 0, message: error },
				});
			});
	};
}
